import styled from 'styled-components';

import type { TeamMember } from '../../content/schemas';

interface TeamMemberCardProps {
  member: TeamMember;
}

const Card = styled.article`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Avatar = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${(p) => p.theme.color.bg[2]};
  border: 1px solid ${(p) => p.theme.color.border.med};
  font-family: ${(p) => p.theme.font.mono};
  font-size: ${(p) => p.theme.step[3]}px;
  font-weight: 700;
  color: ${(p) => p.theme.color.text[0]};
`;

const Name = styled.h3`
  margin: 0;
  font-family: ${(p) => p.theme.font.serif};
  font-size: ${(p) => p.theme.step[5]}px;
`;

const Role = styled.p`
  margin: 0;
  font-size: ${(p) => p.theme.step[1]}px;
  color: ${(p) => p.theme.color.text[3]};
  text-transform: uppercase;
  letter-spacing: 0.08em;
`;

const Bio = styled.p`
  margin: 0;
  font-size: ${(p) => p.theme.step[3]}px;
  color: ${(p) => p.theme.color.text[1]};
  line-height: 1.55;
`;

export function TeamMemberCard({ member }: TeamMemberCardProps) {
  return (
    <Card>
      <Avatar>{member.init}</Avatar>
      <Name>{member.name}</Name>
      <Role>{member.role}</Role>
      <Bio>{member.bio}</Bio>
    </Card>
  );
}
